import { css } from '@/styled-system/css';

/** Hairline edge using box shadow (avoids FOUC vs outlined cards on initial load). */
export const cardBorderStyles = css.raw({
  boxShadow: '0 0 0 1px {colors.Table.Cell.border}',
});
